<app-form-generator
    *ngIf="formGenInput"
    [formGeneratorInput]="formGenInput"
    (formGroupRef)="formGroupRef = $event; onFormGroupCreated('domain', $event)"
></app-form-generator>
